import React from 'react';
import { useInView } from '../hooks/useInView';

const AnimateOnScroll = ({ 
  children, 
  animation = 'fade-up', 
  delay = 0, 
  duration = 260,
  className = '',
  triggerOnce = true,
  ...props 
}) => {
  // eslint-disable-next-line no-unused-vars
  const [ref, isInView, hasBeenInView] = useInView({ 
    threshold: 0.1, 
    rootMargin: '0px 0px -50px 0px',
    triggerOnce 
  });

  const shouldAnimate = triggerOnce ? hasBeenInView : isInView;

  const animationClasses = {
    'fade-up': 'opacity-0 translate-y-3',
    'fade-down': 'opacity-0 -translate-y-3',
    'fade-left': 'opacity-0 translate-x-3',
    'fade-right': 'opacity-0 -translate-x-3',
    'scale-up': 'opacity-0 scale-95',
    'slide-up': 'opacity-0 translate-y-8'
  };

  const baseClasses = 'transition-all ease-out';
  const animationClass = animationClasses[animation] || animationClasses['fade-up'];
  const visibleClass = shouldAnimate ? 'opacity-100 translate-y-0 translate-x-0 scale-100' : animationClass;

  const style = {
    transitionDuration: `${duration}ms`,
    transitionDelay: `${delay}ms`
  };

  return (
    <div
      ref={ref}
      className={`${baseClasses} ${visibleClass} ${className}`}
      style={style}
      {...props}
    >
      {children}
    </div>
  );
};

export default AnimateOnScroll;
